import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import EditForm from "../common/form.vue";
import { ref, onBeforeMount, inject } from "vue";
import { get, set } from "@vueuse/core";
import rules from "../common/rules";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const clinicId = ref(0);

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
});

return (_ctx: any,_cache: any) => {
  return (clinicId.value)
    ? (_openBlock(), _createBlock(EditForm, {
        key: 0,
        clinicId: _unref(get)(clinicId.value),
        rules: _unref(rules)
      }, null, 8, ["clinicId", "rules"]))
    : _createCommentVNode("", true)
}
}

})